import { Injectable } from '@angular/core';
import { APISCockpit } from 'src/service/apis-cockpit';
import { InputItem } from '../../inputcommon/inputcommon.class';
import { InputValue } from 'src/app/Input/inputcharts/inputmodels/inputvalue.model';

const API = '/api/construction-projects/v1/cockpit-inputValues/';

@Injectable({ providedIn: 'root' })
export class InputValueService {

  inputvalue: InputValue = new InputValue();
  inputValues: InputValue[] = [];

  constructor(private apiCockpit: APISCockpit) { }

  async GetInfoInput(itm: InputItem) {
    if (typeof (itm?.companyid) !== 'undefined') {
      const url: string = API + itm.id;
      try {
        const itemResultApi = (await this.apiCockpit.getDataInfo(url));

        this.inputValues = itemResultApi.items;
        if (this.inputValues?.length > 0) {
          this.inputvalue = this.inputValues[0];
        }
        if (itemResultApi.errorList?.length > 0) {
          this.inputvalue.errorList = itemResultApi.errorList;
        }
      }
      catch { }
    }
    return this.inputvalue;
  }

  async GetInfoInputByTask(itm: InputItem) {
    if (typeof (itm?.companyid) !== 'undefined') {
      const url: string = API + itm.id + '/bytask/' + itm.taskid;
      const itemResultApi = (await this.apiCockpit.getDataInfo(url));

      this.inputValues = itemResultApi.items;
      if (this.inputValues?.length > 0) {
        this.inputvalue = this.inputValues[0];
      }
      if (itemResultApi.errorList?.length > 0) {
        this.inputvalue.errorList = itemResultApi.errorList;
      }
    }
    return this.inputvalue;
  }

}
